import { gql } from "urql";

export const getFundOrders = gql`
    query getFundOrders($clientId: GraphQLObjectId!, $date: GraphQLDateString) {
        transferAgentOrders(filter: { tradeDate: $date, clientIdIn: [$clientId] }) {
            _id
            status
            transactionType
            currency
            amount
            units
            instrument {
                _id
                name
            }
            clientId
            valueDate
        }
        parties(filter: { typeIn: [Fund], idIn: [$clientId] }) {
            _id
            fundInfo {
                classes {
                    startNAVPerUnit
                    instrumentId
                }
            }
        }
        navs(clientId: $clientId, date: $date, lastOnly: true) {
            clientId
            data {
                classes {
                    instrumentId
                    name
                    navCurrency
                    navPerUnit
                }
            }
            date
        }
    }
`;
